import React, { useState, useEffect, useContext } from 'react';
import api from '../utils/api';
import './styles/TransferInventoryPage.css';
import { useNavigate, useParams } from 'react-router-dom'; 

const StudentStatusEditPage = () => {
    const { studentId } = useParams();
    const [statusList, setStatusList] = useState([]);
    const [student, setStudent] = useState('');
    const [status, setStatus] = useState('');
    const [statusDate, setStatusDate] = useState('');
    const [reason, setReason] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStudentDetails = async () => {
            try {
                const response = await api.get(`/student/profile/${studentId}`);
                setStudent(response.data.data.student || null);
            } catch (error) {
                console.error("Failed to fetch student details", error);
            }
        };
        fetchStudentDetails();

        
        const fetchStatusList = async () => {
            try {
                const response = await api.get('/utils/getStudentStatusList');
                const statuses = response.data.data.statusList
                .filter(status => status.status_name !== "ONLEAVE")
                .map(status => ({
                    id: status.status_id,
                    name: `${status.status_name}`,
                }));
                setStatusList(statuses);
            } catch (error) {
                console.error("Failed to fetch status list", error);
            }
        };

        fetchStatusList();
    }, [studentId]);
    

    if (!student) return <p>Loading student details...</p>;

    const handleSubmit = async () => {

        if (status === "") {
            alert('Please fill the new status!');
            return;
        }

        if (statusDate === "") {
            alert('Please fill status update date!');
            return;
        }

        
        if (reason === "") {
            alert('Please fill the reason!');
            return;
        }

        
        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }
    
        // Mempersiapkan data untuk dikirim
        const updateStatusData = {
            data: {
                updateStatusData: {
                    student_id: student.student_id, 
                    status_id: status,
                    status_date: statusDate,
                    reason: reason,
                },
            },
        };
    
        try {
            const response = await api.post('/student/status/update', updateStatusData); 
            const successMessage = response.data.message;
            console.log(successMessage);
            navigate('/success', { state: { message: successMessage } });
            
        } catch (error) {
            console.error('Error submitting data:', error);
            console.error('Error adding/updating student:', error);
            navigate('/error', { state: { message: 'Please ask to administrator!' } });
        }
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Student Status Update</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Student Name</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student ? student.student_name : ''} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Student Code</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student ? student.student_code : ''} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Student Program</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student.StudentLevels[0].mainProgram.program_name} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Student Level</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student.StudentLevels[0].Level.level_name} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Add on English Club</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student.StudentLevels[0].addonProgram ? "YES" : "NO"} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Student Status</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student.StudentStatuses[0].Status.status_name} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>New Status</label>
                                    </td>
                                    <td>
                                        <select value={status} onChange={(e) => setStatus(e.target.value)}>
                                            <option value="">Select Status</option>
                                            {statusList.map(status => (
                                                <option key={status.id} value={status.id}>
                                                    {status.name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Status Date</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="date"
                                            name="statusDate"
                                            value={statusDate} 
                                            onChange={e => setStatusDate(e.target.value)}
                                        />
                                    </td>  
                                </tr>
                                <tr>
                                    <td>
                                        <label>Reason</label>
                                    </td>
                                    <td>
                                        <textarea 
                                            name="reason"
                                            value={reason} 
                                            onChange={e => setReason(e.target.value)}
                                        />
                                    </td>  
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="search-container">
                        <button className="profile-button" onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentStatusEditPage;
